import initHeader from '../_modules/header/index'
import initCTA from './cta'
import { handleRefsUs } from '@studybay/common-client-library/ref-handle'
import { revealLinksOnAction } from "../_modules/helpers";

initHeader()
initCTA()
revealLinksOnAction(handleRefsUs)